import React from 'react';

import { Visible } from '../../../core/components';
import { Alert, Button } from '../../../components/ui';

import AddProductForm from './AddProductForm';
import { MODE_ADDING, MODE_SUCCESS } from './constants';

const AddProductView = ({ categoryId, mode, created, forStore = false, onAddAnother, onSuccess }) => {
  // Store submissions come back 'pending' (store-catalog feature): the
  // product is private to the store and unusable until RC approves it.
  const pending = created?.approval_status === 'pending';

  return (
    <div className="users-dark add-new-product container">
      <Visible when={mode === MODE_ADDING}>
        {/* This route is the only consumer that opts into the Fontaine footer
            control — the shared edit form inside ProductSubmissionModal keeps
            the legacy SubmitButton. */}
        <AddProductForm {...{ categoryId, onSuccess, forStore }} fontaineControls />
      </Visible>

      <Visible when={mode === MODE_SUCCESS}>
        <>
          <Alert
            tone="success"
            title={pending ? 'Product submitted for approval' : 'Product added successfully'}
          >
            {pending
              ? 'Retail Circle will review it — track it under Settings → Owner Admin → My Products. It becomes usable once approved.'
              : null}
          </Alert>

          <div className="mt-4">
            <Button size="lg" variant="primary" onClick={onAddAnother}>Add another one</Button>
          </div>
        </>
      </Visible>
    </div>
  );
}

export default AddProductView;
